var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-toolbar',{staticClass:"md-transparent md-absolute",class:_vm.extraNavClasses,attrs:{"id":"toolbar","md-elevation":"0","color-on-scroll":_vm.colorOnScroll}},[_c('div',{staticClass:"md-toolbar-row md-collapse-lateral"},[_c('div',{staticClass:"md-toolbar-section-start"},[_c('h3',{staticClass:"md-title"},[_vm._v("WCC - Newmanizer")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }